(function () {
  'use strict';

  var cache =
    window.__mezettoDirectoryCache ||
    (window.__mezettoDirectoryCache = {});

  function normalizeTR(value) {
    var text = String(value || '');

    try {
      text = text.toLocaleLowerCase('tr-TR');
    } catch (e) {
      text = text.toLowerCase();
    }

    try {
      text = text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}

    return text
      .replace(/ı/g, 'i')
      .replace(/ç/g, 'c')
      .replace(/ğ/g, 'g')
      .replace(/ö/g, 'o')
      .replace(/ş/g, 's')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9\s&+./'’-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleize(value) {
    var text = String(value || '')
      .replace(/[çÇ]/g, 'c')
      .replace(/[ğĞ]/g, 'g')
      .replace(/[ıİI]/g, 'i')
      .replace(/[öÖ]/g, 'o')
      .replace(/[şŞ]/g, 's')
      .replace(/[üÜ]/g, 'u');

    try {
      text = text
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}

    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /*
   * Eski Shopify koleksiyon handle'larında büyük İ harfi,
   * "i + combining dot above" biçiminde kaydedilmiş olabilir.
   *
   * Örnek:
   * İletişim Yayınları → i̇letisim-yayinlari
   */
  function publisherHandleize(value) {
    var name = String(value || '').trim();

    if (name.charAt(0) === 'İ') {
      return 'i\u0307' + handleize(name.slice(1));
    }

    return handleize(name);
  }

  function initial(name) {
    var match = String(name || '')
      .match(/[0-9A-Za-zÇĞİÖŞÜçğıöşü]/);

    if (!match) {
      return '#';
    }

    return /[0-9]/.test(match[0])
      ? '#'
      : match[0].toLocaleUpperCase('tr-TR');
  }

  function localePath(root, path) {
    var prefix =
      root && root !== '/'
        ? String(root).replace(/\/$/, '')
        : '';

    return prefix + path;
  }

  function formatNumber(value) {
    try {
      return Number(value || 0).toLocaleString('tr-TR');
    } catch (e) {
      return String(value || 0);
    }
  }

  function fetchIndex(url) {
    if (cache[url]) {
      return cache[url];
    }

    cache[url] = new Promise(function (resolve, reject) {
      var storageKey = 'mz-directory:' + url;

      try {
        var stored = sessionStorage.getItem(storageKey);

        if (stored) {
          resolve(JSON.parse(stored));
          return;
        }
      } catch (e) {}

      fetch(url, {
        credentials: 'same-origin',
        cache: 'default'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'Dizin dosyası alınamadı (' +
              response.status +
              ')'
            );
          }

          return response.text();
        })
        .then(function (text) {
          var data = JSON.parse(text);

          try {
            sessionStorage.setItem(storageKey, text);
          } catch (e) {}

          resolve(data);
        })
        .catch(function (error) {
          delete cache[url];
          reject(error);
        });
    });

    return cache[url];
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);

    if (className) {
      node.className = className;
    }

    if (text !== undefined && text !== null) {
      node.textContent = text;
    }

    return node;
  }

  function getState() {
    var params = new URLSearchParams(
      window.location.search
    );

    return {
      letter: (
        params.get('letter') || 'ALL'
      ).toLocaleUpperCase('tr-TR'),

      query: params.get('q') || ''
    };
  }

  function setState(state, replace) {
    var url = new URL(window.location.href);

    if (
      state.letter &&
      state.letter !== 'ALL'
    ) {
      url.searchParams.set(
        'letter',
        state.letter
      );
    } else {
      url.searchParams.delete('letter');
    }

    if (state.query) {
      url.searchParams.set(
        'q',
        state.query
      );
    } else {
      url.searchParams.delete('q');
    }

    url.hash = '';

    window.history[
      replace
        ? 'replaceState'
        : 'pushState'
    ](
      {},
      '',
      url.pathname + url.search
    );
  }

  function init(root) {
    if (root.__mzReady) {
      return;
    }

    root.__mzReady = true;

    var kind =
      root.getAttribute(
        'data-directory-type'
      );

    var url =
      root.getAttribute(
        'data-directory-url'
      );

    var localeRoot =
      root.getAttribute(
        'data-locale-root'
      ) || '';

    var pageSize = Math.max(
      12,
      parseInt(
        root.getAttribute(
          'data-page-size'
        ) || '60',
        10
      )
    );

    var search =
      root.querySelector(
        '[data-directory-search]'
      );

    var clear =
      root.querySelector(
        '[data-directory-clear]'
      );

    var grid =
      root.querySelector(
        '[data-directory-grid]'
      );

    var message =
      root.querySelector(
        '[data-directory-message]'
      );

    var statusTitle =
      root.querySelector(
        '[data-directory-status-title]'
      );

    var statusCopy =
      root.querySelector(
        '[data-directory-status-copy]'
      );

    var stat =
      root.querySelector(
        '[data-directory-total]'
      );

    var statLabel =
      root.querySelector(
        '[data-directory-total-label]'
      );

    var more =
      root.querySelector(
        '[data-directory-more]'
      );

    var letterLinks =
      Array.prototype.slice.call(
        root.querySelectorAll(
          '[data-directory-letter]'
        )
      );

    var data = null;
    var visibleLimit = pageSize;
    var searchIndex = null;

    if (!url) {
      showError(
        'Dizin dosyası bağlı değil. Section ayarındaki yedek URL’yi veya custom.mezetto_directory_index mağaza metafield’ını tanımlayın.'
      );

      return;
    }

    if (url.indexOf('//') === 0) {
      url =
        window.location.protocol +
        url;
    }

    root.setAttribute(
      'aria-busy',
      'true'
    );

    fetchIndex(url)
      .then(function (payload) {
        if (
          !payload ||
          payload.schema !== 1
        ) {
          throw new Error(
            'Desteklenmeyen dizin şeması'
          );
        }

        data = payload;

        updateTotal();
        bindEvents();
        render(true);
      })
      .catch(function (error) {
        showError(
          'Dizin yüklenemedi. Sayfayı yenileyin veya daha sonra tekrar deneyin.'
        );

        if (window.console) {
          console.error(
            '[Mezetto Directory]',
            error
          );
        }
      })
      .finally(function () {
        root.setAttribute(
          'aria-busy',
          'false'
        );
      });

    function updateTotal() {
      var count =
        kind === 'authors'
          ? data.counts.authors
          : kind === 'publishers'
            ? data.counts.publishers
            : data.counts.categories;

      if (stat) {
        stat.textContent =
          formatNumber(count);
      }

      if (statLabel) {
        statLabel.textContent =
          kind === 'authors'
            ? 'yazar'
            : kind === 'publishers'
              ? 'yayınevi'
              : 'ana kategori';
      }

      if (kind !== 'categories') {
        letterLinks.forEach(
          function (link) {
            var letter =
              link.getAttribute(
                'data-directory-letter'
              );

            if (letter === 'ALL') {
              return;
            }

            var values =
              (
                data[kind] &&
                data[kind][letter]
              ) || [];

            link.setAttribute(
              'aria-disabled',
              values.length
                ? 'false'
                : 'true'
            );
          }
        );
      }
    }

    function bindEvents() {
      var timer;

      letterLinks.forEach(
        function (link) {
          link.addEventListener(
            'click',
            function (event) {
              if (
                link.getAttribute(
                  'aria-disabled'
                ) === 'true'
              ) {
                event.preventDefault();
                return;
              }

              event.preventDefault();

              var state = getState();

              state.letter =
                link.getAttribute(
                  'data-directory-letter'
                ) || 'ALL';

              state.query = '';

              if (search) {
                search.value = '';
              }

              visibleLimit = pageSize;

              setState(state, false);
              render(false);
            }
          );
        }
      );

      if (search) {
        var initialState = getState();

        search.value =
          initialState.query;

        search.addEventListener(
          'input',
          function () {
            window.clearTimeout(timer);

            timer = window.setTimeout(
              function () {
                var state = getState();

                state.query =
                  search.value.trim();

                if (state.query) {
                  state.letter = 'ALL';
                }

                visibleLimit = pageSize;

                setState(state, true);
                render(false);
              },
              180
            );
          }
        );

        search.addEventListener(
          'keydown',
          function (event) {
            if (
              event.key === 'Escape'
            ) {
              clearSearch();
            }
          }
        );
      }

      if (clear) {
        clear.addEventListener(
          'click',
          clearSearch
        );
      }

      if (more) {
        more.addEventListener(
          'click',
          function () {
            visibleLimit += pageSize;
            render(false);
          }
        );
      }

      window.addEventListener(
        'popstate',
        function () {
          var state = getState();

          if (search) {
            search.value =
              state.query;
          }

          visibleLimit = pageSize;
          render(false);
        }
      );
    }

    function clearSearch() {
      if (search) {
        search.value = '';
        search.focus();
      }

      var state = getState();

      state.query = '';
      visibleLimit = pageSize;

      setState(state, true);
      render(false);
    }

    function showError(text) {
      if (grid) {
        grid.replaceChildren();
      }

      if (message) {
        message.textContent = text;
        message.hidden = false;
      }

      if (more) {
        more.hidden = true;
      }

      root.setAttribute(
        'aria-busy',
        'false'
      );
    }

    function allEntries(type) {
      var collection =
        data[type] || {};

      var result = [];

      (
        data.letters ||
        Object.keys(collection)
      ).forEach(function (letter) {
        var values =
          collection[letter] || [];

        for (
          var i = 0;
          i < values.length;
          i++
        ) {
          result.push(values[i]);
        }
      });

      return result;
    }

    function getSearchIndex(type) {
      if (
        searchIndex &&
        searchIndex.type === type
      ) {
        return searchIndex.items;
      }

      var entries =
        allEntries(type);

      var items =
        entries.map(
          function (entry) {
            return {
              entry: entry,
              key: normalizeTR(
                entry[0]
              )
            };
          }
        );

      searchIndex = {
        type: type,
        items: items
      };

      return items;
    }

    function filteredEntries(state) {
      if (kind === 'categories') {
        return filterCategories(
          state.query
        );
      }

      var source;

      if (state.query) {
        var terms =
          normalizeTR(state.query)
            .split(' ')
            .filter(Boolean);

        source =
          getSearchIndex(kind)
            .filter(function (item) {
              return terms.every(
                function (term) {
                  return (
                    item.key.indexOf(
                      term
                    ) !== -1
                  );
                }
              );
            })
            .map(function (item) {
              return item.entry;
            });
      } else if (
        state.letter &&
        state.letter !== 'ALL'
      ) {
        source =
          (
            data[kind] &&
            data[kind][state.letter]
          ) || [];
      } else {
        source =
          allEntries(kind);
      }

      return source;
    }

    function filterCategories(query) {
      var categories =
        data.categories || [];

      var q = normalizeTR(query);

      if (!q) {
        return categories;
      }

      var terms =
        q.split(' ').filter(Boolean);

      return categories.reduce(
        function (
          result,
          category
        ) {
          var parentMatch =
            terms.every(
              function (term) {
                return (
                  normalizeTR(
                    category[0]
                  ).indexOf(term) !== -1
                );
              }
            );

          var children =
            category[3] || [];

          var filteredChildren =
            parentMatch
              ? children
              : children.filter(
                  function (child) {
                    var key =
                      normalizeTR(
                        child[0]
                      );

                    return terms.every(
                      function (term) {
                        return (
                          key.indexOf(
                            term
                          ) !== -1
                        );
                      }
                    );
                  }
                );

          if (
            parentMatch ||
            filteredChildren.length
          ) {
            result.push([
              category[0],
              category[1],
              category[2],
              filteredChildren
            ]);
          }

          return result;
        },
        []
      );
    }

    function render(firstRender) {
      if (!data || !grid) {
        return;
      }

      var state = getState();

      if (kind === 'categories') {
        state.letter = 'ALL';
      }

      if (clear) {
        clear.hidden =
          !state.query;
      }

      updateLetters(state);

      var entries =
        filteredEntries(state);

      var shown =
        entries.slice(
          0,
          visibleLimit
        );

      grid.replaceChildren();

      grid.className =
        kind === 'categories'
          ? 'mz-directory__category-stack'
          : 'mz-directory__grid';

      if (kind === 'categories') {
        shown.forEach(
          function (
            category,
            index
          ) {
            renderCategory(
              category,
              index,
              Boolean(state.query)
            );
          }
        );
      } else {
        shown.forEach(renderCard);
      }

      var queryLabel =
        state.query
          ? '“' +
            state.query +
            '” araması'
          : state.letter === 'ALL'
            ? 'Tümü'
            : state.letter +
              ' harfi';

      if (statusTitle) {
        statusTitle.textContent =
          queryLabel;
      }

      if (statusCopy) {
        statusCopy.textContent =
          formatNumber(entries.length) +
          ' sonuç · ' +
          formatNumber(
            Math.min(
              shown.length,
              entries.length
            )
          ) +
          ' gösteriliyor';
      }

      if (message) {
        message.hidden =
          entries.length !== 0;

        if (!entries.length) {
          message.textContent =
            'Aradığınız ölçütlere uygun sonuç bulunamadı.';
        }
      }

      if (more) {
        more.hidden =
          entries.length <=
          shown.length;

        if (!more.hidden) {
          more.textContent =
            'Daha fazla göster (' +
            formatNumber(
              entries.length -
              shown.length
            ) +
            ')';
        }
      }

      root.setAttribute(
        'aria-busy',
        'false'
      );

      if (
        !firstRender &&
        grid.scrollIntoView &&
        state.letter !== 'ALL'
      ) {
        grid.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }

    function updateLetters(state) {
      letterLinks.forEach(
        function (link) {
          var selected =
            !state.query &&
            (
              link.getAttribute(
                'data-directory-letter'
              ) || 'ALL'
            ) === state.letter;

          if (selected) {
            link.setAttribute(
              'aria-current',
              'page'
            );
          } else {
            link.removeAttribute(
              'aria-current'
            );
          }
        }
      );
    }

    function renderCard(entry) {
      var name = entry[0];
      var count = entry[1];
      var path;

      /*
       * Yayınevleri doğrudan kendi koleksiyonlarına gider.
       *
       * İ ile başlayan mevcut koleksiyonlarda Shopify'daki
       * "i + combining dot above" handle yapısı korunur.
       *
       * Örnek:
       * İletişim Yayınları
       * → /collections/i̇letisim-yayinlari
       */
      if (kind === 'publishers') {
        path = localePath(
          localeRoot,
          '/collections/' +
          publisherHandleize(name)
        );
      } else {
        /*
         * Yazarlar için mevcut etiketli filtre yapısı korunur.
         */
        path = localePath(
          localeRoot,
          '/collections/all/' +
          handleize(
            'Yazar:' + name
          )
        );
      }

      var li = el(
        'li',
        'mz-directory__card'
      );

      var link = el(
        'a',
        'mz-directory__link'
      );

      link.href = path;

      link.setAttribute(
        'aria-label',
        name +
        ' kitaplarını görüntüle'
      );

      link.appendChild(
        el(
          'span',
          'mz-directory__initial',
          initial(name)
        )
      );

      var copy = el(
        'span',
        'mz-directory__card-copy'
      );

      copy.appendChild(
        el(
          'span',
          'mz-directory__name',
          name
        )
      );

      copy.appendChild(
        el(
          'span',
          'mz-directory__meta',
          formatNumber(count) +
          ' kitap'
        )
      );

      link.appendChild(copy);

      var arrow = el(
        'span',
        'mz-directory__arrow',
        '→'
      );

      arrow.setAttribute(
        'aria-hidden',
        'true'
      );

      link.appendChild(arrow);
      li.appendChild(link);
      grid.appendChild(li);
    }

    function renderCategory(
      category,
      index,
      openByDefault
    ) {
      var article = el(
        'article',
        'mz-directory__category'
      );

      var head = el(
        'div',
        'mz-directory__category-head'
      );

      var toggle = el(
        'button',
        'mz-directory__category-toggle'
      );

      toggle.type = 'button';

      var bodyId =
        root.id +
        '-category-' +
        index;

      toggle.setAttribute(
        'aria-controls',
        bodyId
      );

      toggle.setAttribute(
        'aria-expanded',
        openByDefault
          ? 'true'
          : 'false'
      );

      toggle.appendChild(
        el(
          'span',
          'mz-directory__category-title',
          category[0]
        )
      );

      toggle.appendChild(
        el(
          'span',
          'mz-directory__category-count',
          formatNumber(
            category[2]
          ) +
          ' kitap · ' +
          formatNumber(
            (
              category[3] || []
            ).length
          ) +
          ' alt kategori'
        )
      );

      var mainLink = el(
        'a',
        'mz-directory__category-main',
        'Ana kategori →'
      );

      mainLink.href =
        localePath(
          localeRoot,
          '/collections/' +
          category[1]
        );

      head.appendChild(toggle);
      head.appendChild(mainLink);
      article.appendChild(head);

      var body = el(
        'div',
        'mz-directory__category-body'
      );

      body.id = bodyId;
      body.hidden = !openByDefault;

      var list = el(
        'ul',
        'mz-directory__subcategory-grid'
      );

      (
        category[3] || []
      ).forEach(
        function (child) {
          var item = el('li');

          var link = el(
            'a',
            'mz-directory__subcategory-link'
          );

          link.href =
            localePath(
              localeRoot,
              '/collections/' +
              child[1]
            );

          link.appendChild(
            el(
              'span',
              '',
              child[0]
            )
          );

          link.appendChild(
            el(
              'span',
              'mz-directory__subcategory-count',
              formatNumber(
                child[2]
              ) +
              ' kitap'
            )
          );

          item.appendChild(link);
          list.appendChild(item);
        }
      );

      body.appendChild(list);
      article.appendChild(body);

      toggle.addEventListener(
        'click',
        function () {
          var open =
            toggle.getAttribute(
              'aria-expanded'
            ) === 'true';

          toggle.setAttribute(
            'aria-expanded',
            open
              ? 'false'
              : 'true'
          );

          body.hidden = open;
        }
      );

      grid.appendChild(article);
    }
  }

  function boot() {
    document
      .querySelectorAll(
        '[data-mezetto-directory]'
      )
      .forEach(init);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    boot
  );
})();